
import { CircularProgress } from '@mui/material';
import { React, useState } from 'react';
import Form from 'react-bootstrap/Form';

import Modal from 'react-bootstrap/Modal';

export default ({ show, message }) => {
  return (
    <Modal style={{ paddingTop: '10vh', color: 'rgb(0, 0, 0, .8)', backgroundColor: 'rgb(0, 0, 0, 0.2)' }} dialogClassName="modal-30w" show={show}>
      <Modal.Header style={{ border: 0, color: '#ee7170', padding: 0 }}>
      </Modal.Header>
      <Modal.Body style={{ padding: '1vw', paddingTop: '2vw', textAlign: 'center' }}>
        <p style={{ fontWeight: '500', fontSize: '1vw', marginBottom: '1vw' }}>{message}</p>
        <div><p style={{ fontSize: '0.8vw', fontWeight: '400', marginBottom: '1vw' }}>Please wait as this might take a while</p></div>
        <Form.Group controlId="formFileLg" className="mb-3">
          <div style={{ textAlign: 'center', marginTop: '2vw', marginBottom: '1vw' }}>

            <CircularProgress color="inherit" size="2vw" />
          </div>

        </Form.Group>
      </Modal.Body>
    </Modal>

  );
};
